import React from 'react';
import { TFunc } from '../../../../../../../hooks/useNamespacedTranslation';
import InputLabel from '../../../../../../../components/form/InputLabel';
import TextareaAutosize from 'react-textarea-autosize';
import { TicketFormValues } from '../types';

type Props = {
  t: TFunc;
  onFieldChange: (step: Partial<TicketFormValues>) => void;
  value: TicketFormValues | null;
};
export const DetailsFormField: React.FC<React.PropsWithChildren<Props>> = ({
  t,
  onFieldChange,
  value,
}) => {
  return (
    <>
      <InputLabel label={t('form.fields.details')} />
      <TextareaAutosize
        defaultValue={value ? value.details : ''}
        className="form-control"
        name="details"
        onChange={(event) =>
          onFieldChange({
            details: event.target.value,
            preview: { ...value?.preview, details: event.target.value },
          })
        }
        placeholder={t('form.fields.detailsPlaceholder')}
        minRows={4}
      />
    </>
  );
};
